import Trainer from './trainer'
import RacesByTrainer from './racesByTrainer'
import Race from './races'
import RaceQuestion from './raceQuestion'
import RaceQuote from './raceQuote'
import RaceResume from './raceResume'
import LoadingQueue from './LoadingQueue'
import Alert from './Alert'
import runners from './runners'
import trainers from './trainers'
export default {
  Trainer,
  RacesByTrainer,
  Race,
  RaceQuestion,
  RaceQuote,
  RaceResume,
  LoadingQueue,
  runners,
  trainers,
  Alert
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js